import { z } from 'zod';
import { metricColoringValidator } from '@/features/DataGridColoring';
import { DataGridViewType } from '@/features/DataGridTypeSwitcher';
import { filtersValidator } from '@/features/filters';
import type { ColumnsConfig } from '@/shared/types';
import {
  columnsWidthStateValidator,
  DateScale,
  serializedDateRangeValueObjectValidator,
  sortingValidator,
} from '@/shared/types';

export enum CohortAgeScale {
  DAY = 1,
  THREE_DAYS = 3,
  WEEK = 7,
  FOURTEEN_DAYS = 14,
  THIRTY_DAYS = 30,
}

export const dataConfigValidator = z.object({
  dateRange: serializedDateRangeValueObjectValidator,
  dateScale: z.nativeEnum(DateScale),
  probabilisticAttribution: z.boolean(),
  cohortAgeScale: z.nativeEnum(CohortAgeScale),
  dimensions: z.array(z.string()),
  metric: z.string(),
  isForecasted: z.boolean(),
  filters: filtersValidator,
  sorting: sortingValidator,
  rowHeight: z.number(),
  columnsWidth: columnsWidthStateValidator,
  metricsColoring: z.array(metricColoringValidator).optional(),
  dataGridViewType: z.optional(z.nativeEnum(DataGridViewType)),
});

export type DataConfig = z.infer<typeof dataConfigValidator>;

export interface DataUpdateInfo {
  updateTime: string;
}

export interface ColumnsMeta {
  defaultColumns: {
    dimensions: string[];
    metric: string;
  };
  config: ColumnsConfig;
  dimensions: string[];
  metrics: string[];
}

type DataRow = Record<string, string | number | undefined>;

export interface DataResponse {
  rows: DataRow[];
  columns: string[];
  hasNextPage: boolean;
}

export interface TreeDataResponse {
  rows: DataRow[];
  columns: string[];
}
